import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaLightbulb,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CreativeVideoProductionCompanyInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Creative Video Production Company in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unleash Your Brand’s Story</Subheading>}
        heading={
          <Heading>
            Leading <span tw="text-primary-500">Creative Video Production</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our creative video production company in **Al
            Barsha** crafts visually stunning, narrative-driven videos that
            captivate audiences. From cinematic brand stories to innovative
            social media content, we bring your vision to life with unmatched
            creativity.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1601506521937-0b4218f2e801?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Film production setup
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Creative lighting effects
          "https://images.unsplash.com/photo-1580983218765-f663bec07b37?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Creative Video Production Experts in Al Barsha"
        description="We deliver innovative, high-impact videos that set your brand apart."
        cards={[
          {
            icon: <FaLightbulb color="#ff5464" size={40} />,
            title: "Innovative Storytelling",
            description: "Unique narratives that resonate with your audience.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Cinematic Visuals",
            description: "Stunning, high-quality footage that captivates.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising creativity.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Optimized",
            description:
              "Content tailored for social media, websites, and campaigns.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Creativity",
            description: "Al Barsha’s choice for visionary video production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From concept to final edit, we handle it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Creative Video Production Process"
        description={
          <Description>
            We bring your ideas to life through a streamlined, creative process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your brand and creative vision.</li>
              <li>Concept Development: Craft a bold, unique storyline.</li>
              <li>
                Filming: Capture cinematic footage with top-tier equipment.
              </li>
              <li>
                Editing: Enhance with effects, music, and innovative visuals.
              </li>
              <li>Review: Ensure the video aligns with your creative goals.</li>
              <li>
                Delivery: Provide polished content ready for your platforms.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Studio production setup
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Artistic video composition
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Creative Video Wins in Al Barsha"
        description="Our innovative videos have transformed brands in Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description:
              "Drove massive engagement with a creative social media video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Recognition",
            description: "Elevated visibility with a cinematic brand story.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Acclaim",
            description: "97% satisfaction from creative video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Creative Videos?</Subheading>}
        heading="Creative Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset, the leading creative video production
            company in Al Barsha. Create bold, cinematic videos that captivate
            and inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1536240478700-b869070f9279?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1546412414-e1885259563a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline
          "https://images.unsplash.com/photo-1523207911345-32501502db22?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
